module.exports = __webpack_public_path__ + "img/clipboard-minus.0593e213.svg";